import { useState } from "react";
import TaskHeader from "components/task/header/TaskHeader";
import { Box, Stack } from "@mui/joy";
import { ProgramContentType } from "data/BlockComponent";
import {
  THOUGHTRECORD_DOMAIN,
  THOUGHTRECORD_LIST_ENDPOINT,
  thoughtRecordApi,
  ThoughtRecordType,
} from "api/thoughtRecordApi";
import { useRecoilValue } from "recoil";
import { useQuery } from "@tanstack/react-query";
import { userAtom } from "recoil/userAtom";
import ThoughtRecordListForMobile from "./ThoughtRecordListForMobile";
import { theme } from "styles/theme";
import useGetDeviceInfo from "hooks/useGetDeviceInfo";

export default function ThoughtRecordMobileListPage() {
  const user = useRecoilValue(userAtom);
  const { homeIndicatorHeight } = useGetDeviceInfo();

  const [data, setData] = useState<ProgramContentType[] | undefined>();

  const [thoughtRecordList, setThoughtRecordList] = useState<
    ThoughtRecordType[] | undefined
  >();

  const [currentThoughtRecord, setCurrentThoughtRecord] = useState<
    ThoughtRecordType | undefined
  >();

  useQuery(
    [THOUGHTRECORD_DOMAIN, THOUGHTRECORD_LIST_ENDPOINT, user?.userId!!],
    () => thoughtRecordApi.getList(user?.userId!!),
    {
      enabled: !!user?.userId,
      onSuccess: (data) => {
        setThoughtRecordList((prevList) => {
          return data.result?.map((each) => ({
            ...each,
            shouldBeDone: each?.isDone
              ? false
              : prevList?.find(
                  (element) =>
                    element.thoughtRecordKey === each.thoughtRecordKey
                )?.shouldBeDone,
          }));
        });
      },
    }
  );

  return (
    <Stack
      direction="column"
      sx={{
        height: "100%",
        width: "100%",
        backgroundColor: theme.vars.palette.Background.Level1,
      }}
    >
      <Box
        sx={{
          flex: "none",
          zIndex: 100,
        }}
      >
        <TaskHeader
          key={`thoughtRecords:${user?.userId}`}
          taskKey={`thoughtRecords:${user?.userId}`}
          title={`생각기록지`}
          contentData={data}
          setContentData={setData}
        />
      </Box>
      <Stack
        sx={{
          flex: 1,
          overflow: "hidden",
          position: "relative",
          "::after": {
            content: '""',
            position: "absolute",
            bottom: 0,
            left: 0,
            right: 0,
            height: `${homeIndicatorHeight}px`,
            background: `linear-gradient(180deg, rgba(246, 249, 250, 0) 0%, ${theme.vars.palette.Background.Level1} 20%)`,
            pointerEvents: "none",
          },
        }}
      >
        <ThoughtRecordListForMobile
          thoughtRecordList={thoughtRecordList}
          currentThoughtRecord={currentThoughtRecord}
          setCurrentThoughtRecord={setCurrentThoughtRecord}
        />
      </Stack>
    </Stack>
  );
}
